import React, { PureComponent } from "react";
import { WithTranslation, withTranslation } from "react-i18next";

import TestIds from "../../testIds";
import { WithBusyIndicator, withBusyIndicator } from "../busyIndicator/withBusyIndicator";
import { Separator } from "../separator/Separator";
import { NoData } from "../table/NoData";
import ListItem, { IListItem } from "./ListItem";
import { NoDataWrapper, StyledObjectList } from "./ObjectList.styles";


export interface ISection {
    id: string;
    name?: string;
    children: IListItem[];
}

export interface IObjectListProps extends WithTranslation, WithBusyIndicator {
    listId?: string;
    sections: ISection[];
    noDataText?: string;
    onTriggerAction?: (itemId: string, action: string) => void;
    appliedText?: string;
}

class ObjectList extends PureComponent<IObjectListProps> {
    renderSections = (sections: ISection[]) => {
        return sections.map((section, idx) => {
            // renders separator if it's not first section or name is explicitly specified
            const renderSeparator = idx || section.name;
            const isPreviousSectionLastItemDefault = !!sections[idx - 1]?.children?.slice(-1)[0]?.isDefault;
            return (
                <React.Fragment key={section.id}>
                    {renderSeparator &&
                        <Separator label={section.name} isEmphasised={isPreviousSectionLastItemDefault} isBold/>}
                    {this.renderListItems(section.children)}
                </React.Fragment>
            );
        });
    };

    renderListItems = (items: IListItem[]) => {
        return items.map((item, idx) => {
            const id = `${this.props.listId}/${item.id}`;
            const key = `${this.props.listId}/${item.key ?? item.id}`;
            // isEmphasized separator should be the first after all the default items
            const isLastDefault = !!items[idx].isDefault && (!items[idx + 1] || !items[idx + 1].isDefault);

            return (
                <React.Fragment key={key}>
                    <ListItem id={id}  {...item} appliedText={this.props.appliedText}
                              onTriggerAction={this.props.onTriggerAction}/>
                    {idx !== items.length - 1 ? <Separator isEmphasised={isLastDefault} isBold/> : ""}
                </React.Fragment>
            );
        });
    };

    renderNoData = () => (
        <NoDataWrapper>
            <NoData noDataText={this.props.noDataText ?? this.props.t("Components:ObjectList.NoData")}/>
        </NoDataWrapper>
    );

    render = () => {
        const sectionsWithChildren = this.props.sections?.filter(section => section.children?.length);

        return (
            <StyledObjectList data-testid={TestIds.ObjectList}>
                {this.props.busyIndicator}
                {!this.props.busy &&
                    (sectionsWithChildren?.length ? this.renderSections(sectionsWithChildren) : this.renderNoData())}
            </StyledObjectList>
        );
    };
}


export default withBusyIndicator({ passBusyIndicator: true })(withTranslation(["Components"])(ObjectList));